/** @jsxRuntime classic */
/** @jsx jsx */
import { Container, Text, Title } from '@bottlebooks/gatsby-design-system';
import { jsx } from 'theme-ui';
import PreviewLayout from '../Layout/PreviewLayout';

export default function ProducerPreviewPage({
  producerId,
  collectionId,
  locale,
}) {
  return (
    <PreviewLayout locale={locale}>
      <Container>
        <Title sx={{ marginY: 3 }}>Nothing here.</Title>
        <Text>
          We're sorry, previewing producers isn't supported currently.
        </Text>
      </Container>
    </PreviewLayout>
  );
}
